export const NAV_HEIGHT = 48; // Deprecated do not use
